import React, { useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Button, Form, Header, Icon, Modal } from "semantic-ui-react";
import axios from "axios";
import { message } from "antd";

function ResetPassword({ open }) {
  const [newPassword, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [errors, setErrors] = useState({
    newPassword: false,
    confirm: false,
  });
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const { state } = useLocation();
  const { email } = state;

  // console.log("----", useLocation());

  const handleResetPassword = async () => {
    try {
      if (!newPassword) return setErrors({ ...errors, newPassword: true });

      if (newPassword !== confirm)
        return setErrors({ ...errors, confirm: true });

      setLoading(true);

      const response = await axios.patch(
        `${process.env.REACT_APP_API_URL}/users/reset-password?email=${email}`,
        { newPassword }
      );

      if (response.status === 200) {
        setLoading(false);
        return history.push({ pathname: "/auth", state });
      }
    } catch (error) {
      if (error.message === "Network Error") {
        return message.error(error.message);
      }
      if (error?.response?.status === 404) {
        return message.error(error.response.data.error);
      }
      if (error?.response?.status === 500) {
        return message.error(error.response.data.error);
      }
    }
  };

  return (
    <Modal
      closeIcon
      open={open}
      onClose={() => history.push("/auth")}
      centered
      dimmer="inverted"
      size="tiny"
      style={{
        position: "relative",
        height: "41%",
        overflow: "hidden",
      }}
    >
      <Header icon="repeat" content="Reset Password" textAlign="center" />
      <Modal.Content>
        {/* {!showMessage.show ? (
        ) : (
          <Message success>
            {showMessage.message}
            <Link to={"/auth/reset-password/verify"}>
              <Button basic content='OK' />
            </Link>
          </Message>
        )} */}
        <Form>
          <Form.Input
            fluid
            icon="lock"
            iconPosition="left"
            placeholder="New password"
            type="password"
            error={errors.newPassword}
            onChange={(e) => {
              setPassword(e.target.value);
              setErrors({ ...errors, newPassword: false });
            }}
          />
          <Form.Input
            fluid
            icon="key"
            iconPosition="left"
            type="password"
            placeholder="Confirm password"
            error={errors.confirm && newPassword !== confirm}
            onChange={(e) => {
              setConfirm(e.target.value);
              // setErrors({ ...errors, email: false });
            }}
          />
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color="red" circular onClick={() => history.push("/auth")}>
          <Icon name="remove" /> Cancel
        </Button>
        <Button
          color="dodge blue"
          circular
          loading={loading}
          onClick={handleResetPassword}
        >
          <Icon name="checkmark" /> Send email
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default ResetPassword;
